import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { LucideAngularModule, Search, X } from 'lucide-angular';

/**
 * Reusable search input that emits each text change to its parent.
 */
@Component({
  selector: 'app-search-bar',
  imports: [LucideAngularModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.css',
})
export class SearchBarComponent {
  /** Placeholder text shown inside the input. */
  readonly placeholder = input('Search...');

  /** Emits the raw string value on every keystroke (debounce handled by consumer). */
  readonly search = output<string>();

  /** Leading search icon. */
  readonly SearchIcon = Search;
  /** Clear button icon. */
  readonly XIcon      = X;

  /** Current input value displayed by the search field. */
  readonly value = signal('');

  /**
   * Updates local state and emits the typed search term.
   *
   * @param event Native input event from the search field.
   */
  onInput(event: Event): void {
    const val = (event.target as HTMLInputElement).value;
    this.value.set(val);
    this.search.emit(val);
  }

  /**
   * Clears the search value and notifies the parent with an empty term.
   */
  clear(): void {
    this.value.set('');
    this.search.emit('');
  }
}
